import src from "IMAGE";
export default { src, width: 592, height: 16, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAICBQAOESEEFxwsESowQicpL0EnFxwsEQ8TJAUDBAkAMb0DDMAh4GYAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
